import React from 'react'
import styled from 'styled-components'
import NavBar from '../components/navBar'
import Roadmap from '../components/roadmap'

const MainContainer = styled.div`
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
`

const RoadmapView = (props) => {

    return(
        <MainContainer>
            {props.config.project.topBar && <props.config.project.topBar/>}
            <NavBar {...props}/>
            <Roadmap {...props}/>
        </MainContainer>
    )
}

export default RoadmapView
